import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import {
  buildLearningTopicPath,
  getPrimaryEducationTopic,
  getQuestionHelpText
} from '../../lib/educationContent';

const QuestionHelpButton = ({ question, topics = [], matterId, questionKey }) => {
  const [open, setOpen] = useState(false);
  const primaryTopicRow = getPrimaryEducationTopic(topics);
  const helpText = getQuestionHelpText(question, primaryTopicRow);

  if (!helpText) return null;

  const topic = primaryTopicRow?.topic;

  return (
    <span
      className="relative inline-flex group/help"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        aria-expanded={open}
        aria-label={`Help for ${question.question_text}`}
        onClick={() => setOpen((current) => !current)}
        onBlur={(event) => {
          if (!event.currentTarget.parentElement?.contains(event.relatedTarget)) {
            setOpen(false);
          }
        }}
        className="mt-0.5 inline-flex h-5 w-5 items-center justify-center rounded-full text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
      >
        <SafeIcon icon={FiIcons.FiHelpCircle} className="h-4 w-4" />
      </button>
      <span
        className={`absolute left-1/2 top-7 z-20 w-80 -translate-x-1/2 rounded-lg border border-slate-200 bg-white p-3 text-left text-xs font-normal leading-relaxed text-slate-600 shadow-lg ${
          open ? 'block' : 'hidden group-focus-within/help:block group-hover/help:block'
        }`}
      >
        {topic && (
          <span className="mb-1 block text-[10px] font-bold uppercase tracking-widest text-blue-700">
            {primaryTopicRow.context_label || topic.title}
          </span>
        )}
        <span className="block">{helpText}</span>
        {topic && (
          <Link
            to={buildLearningTopicPath({ slug: topic.slug, matterId, questionKey })}
            className="mt-3 inline-flex items-center text-[10px] font-bold uppercase tracking-widest text-blue-700 hover:text-blue-800"
            onClick={() => setOpen(false)}
          >
            Learn more
            <SafeIcon icon={FiIcons.FiArrowRight} className="ml-1 h-3 w-3" />
          </Link>
        )}
      </span>
    </span>
  );
};

export default QuestionHelpButton;
